/**
 * Absolutely-positioned SVG overlay rendering pre-generated sketchy paths.
 *
 * The viewBox matches the element's measured pixel dimensions 1:1 (no
 * normalized stretching), and overflow stays visible so the rough strokes'
 * characteristic overshoot at corners is not clipped.
 */
import type { SketchPath } from "./node-paths";

export function SketchSvg({
  width,
  height,
  paths,
}: {
  readonly width: number;
  readonly height: number;
  readonly paths: readonly SketchPath[];
}) {
  return (
    <svg
      viewBox={`0 0 ${String(width)} ${String(height)}`}
      data-testid="sketch-overlay"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "visible",
      }}
    >
      {paths.map((p, i) => (
        <path
          // Paths are regenerated wholesale; index keys are stable per output.
          key={i}
          d={p.d}
          stroke={p.stroke}
          strokeWidth={p.strokeWidth}
          fill={p.fill}
        />
      ))}
    </svg>
  );
}
